import React, { useMemo, useState } from 'react'
import styles from './styles.module.scss'
import TextFilter from '../../../../shared/components/filters/text-filter'
import UserFilter from '../../../../shared/components/filters/user-filter'
import UnTable from '../../../../shared/components/un-table'
import { UserShow } from '../../../../shared/components'
import { Chip } from '@mui/material'
import { useProjects } from 'src/entities/project'
import TagsView from '../../../../old-app/components/ui/TagsView'
import ProjectTagsFilter from '../../../../shared/components/filters/project-tags-filter'
import moment from 'moment/moment'
import DateFilter from '../../../../shared/components/filters/date-filter'
import useProjectTemplates from '../../model/useProjectTemplates'
import { useLocation, useParams } from 'react-router-dom'
import TaskMoreFilters from '../../../../old-app/components/task/TaskMoreFilters'
import { useTranslation } from 'react-i18next'

interface IProps {}

const defaultPerPage = 50

const ProjectTemplatesTable: React.FC<IProps> = () => {
	const { t } = useTranslation()

	const columns = useMemo(
		() => [
			{
				id: 2,
				label: 'Название',
				field: 'name',
				className: 'tt-flex-1',
				render: (listItem: any) => (
					<p className="my-truncate-one tt-whitespace-pre-wrap tt-break-all tt-flex-1 tt-min-w-76  tt-text-14 tt-text-left tt-font-medium tt-text-black">
						{listItem?.name}
					</p>
				),
			},
			{
				id: 3,
				label: 'Автор',
				field: 'author',
				className: 'tt-max-w-192 tt-min-w-192 tt-w-192',
				render: (listItem: any) => <>{listItem?.author_view && <UserShow user={listItem?.author_view} />}</>,
			},
			{
				id: 5,
				label: '',
				field: '',
				className: 'tt-max-w-[44px] tt-min-w-[44px] tt-w-[44px]',
				render: (listItem: any) => <></>,
			},
		],
		[]
	)

	const filters = useMemo(
		() => [
			{
				id: 2,
				render: (listItem: any) => (
					<>
						<TextFilter placeholder={t('title')} />
					</>
				),
			},
			{
				id: 3,
				render: (listItem: any) => (
					<>
						<UserFilter isAll placeholder={t('author')} field="author" />
					</>
				),
			},
			{
				id: 5,
				render: (listItem: any) => (
					<>
						<TaskMoreFilters
							prefix={''}
							hideTaskParamsFilter
							hideSkelet={{ deadline_sort: true }}
							isLabel={undefined}
							allProjectsMode={true}
							projectId={undefined}
							id={undefined}
						/>
					</>
				),
			},
		],
		[]
	)

	const heads = columns.map((column, index) => {
		return { ...column, render: filters[index]?.render }
	})

	const { search } = useLocation()
	const { templateID } = useParams()
	const [perPage, setPerPage] = useState(defaultPerPage)
	const { projectTemplates, isLoading, meta } = useProjectTemplates({ params: { per_page: perPage, page: 1 } })
	const page = '/projects-templates'

	const link = (id: Id) => `${page}/${id}${search}`

	const loadMore = () => {
		setPerPage((prevState) => prevState + defaultPerPage)
	}
	const rowActive = (id: Id) => {
		return id === templateID
	}

	return (
		<div className="tt-flex tt-flex-col tt-overflow-auto table-scroll">
			<UnTable
				rowActive={rowActive}
				loadMore={loadMore}
				meta={meta}
				isLoading={isLoading}
				emptyPlaceholder={t('empty_project_templates_list')}
				link={link}
				heads={heads}
				list={projectTemplates}
				columns={columns}
			/>
		</div>
	)
}

export default ProjectTemplatesTable
